module.exports = __webpack_public_path__ + "static/giphy-6b04ea8d6a008958c14ece74ab4d4f63.gif";